import { drugsMandatoryTreatmentAddressNameFields } from 'constants/enums/people';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { hasYesOrNo } from 'models/validate';
import { SubstanceDrugsMandatoryTreatmentModel } from './types';
import { substanceDrugsMandatoryTreatmentItemValidator } from './validators/item';

const substanceDrugsMandatoryTreatmentValidator: ValidateJSModel<SubstanceDrugsMandatoryTreatmentModel> = {
  TreatmentOrdered: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes, attribueName, options) => {
    if (attributes?.TreatmentOrdered && attributes?.TreatmentOrdered.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, drugsMandatoryTreatmentAddressNameFields);

      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }

      return {
        ...additionalValidation,
        presence: true,
        accordion: { validator: substanceDrugsMandatoryTreatmentItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};
export default substanceDrugsMandatoryTreatmentValidator;
